export var StatusChapterInteraction;
(function (StatusChapterInteraction) {
    StatusChapterInteraction["DONE"] = "done";
    StatusChapterInteraction["DOING"] = "doing";
    StatusChapterInteraction["UNSEEN"] = "unseen";
})(StatusChapterInteraction || (StatusChapterInteraction = {}));
